/* 30/09 perf fiche : sur la fiche produit, démarre juste APRÈS le 1er affichage (#almea-pdp-pret) — élément caché, prêt quelques ms après. */
/* 30/09 perf : ce fichier est chargé en « async » (il ne bloque plus l'affichage de la page).
   Il attend son repère #almk-panier (posé juste avant la balise script) pour démarrer exactement au même moment qu'avant.
   Sans repère sur la page : il démarre à la fin du chargement. */
(function almBoot(){
  if (document.readyState === 'loading' && (!document.getElementById('almk-panier') || (document.getElementById('almea-render-barrier') && !document.getElementById('almea-pdp-pret')))) { setTimeout(almBoot, 20); return; }
/* Maison Almea — moteur du tiroir panier (MzCartV2). 17/09/2026 perf : sorti de sections/z-paniermasazen.liquid ;
   les reglages Liquid restent dans la section et arrivent par window.__MzCfg. */
window.MzCartV2 = (function() {
  'use strict';
  var __C = window.__MzCfg || {};
  var SHOW_TIMER = __C.SHOW_TIMER;
  var TIMER_LABEL = __C.TIMER_LABEL;
  var TIMER_URGENCY = __C.TIMER_URGENCY;
  var TIMER_MINUTES = __C.TIMER_MINUTES;
  var SHOW_REVIEW = __C.SHOW_REVIEW;
  var REVIEW_SLIDER = __C.REVIEW_SLIDER;
  var REVIEW_STARS_COLOR = __C.REVIEW_STARS_COLOR;
  var REVIEW_AVATAR_BORDER = __C.REVIEW_AVATAR_BORDER;
  var REVIEWS = __C.REVIEWS;
  var EMPTY_TITLE = __C.EMPTY_TITLE;
  var EMPTY_TEXT = __C.EMPTY_TEXT;
  var SUBTOTAL_TEXT = __C.SUBTOTAL_TEXT;
  var SHIPPING_TEXT = __C.SHIPPING_TEXT;
  var SHIPPING_VALUE = __C.SHIPPING_VALUE;
  var TOTAL_TEXT = __C.TOTAL_TEXT;
  var SHOW_SUMMARY = __C.SHOW_SUMMARY;
  var TIMELINE_LABEL = __C.TIMELINE_LABEL;
  var STEP1 = __C.STEP1;
  var STEP2 = __C.STEP2;
  var STEP3 = __C.STEP3;
  var SHOW_TIMELINE = __C.SHOW_TIMELINE;
  var TIMELINE_DATE_FORMAT = __C.TIMELINE_DATE_FORMAT;
  var SHIPPED_MIN = __C.SHIPPED_MIN;
  var SHIPPED_MAX = __C.SHIPPED_MAX;
  var DELIVERED_MIN = __C.DELIVERED_MIN;
  var DELIVERED_MAX = __C.DELIVERED_MAX;
  var SHOW_UPSELL = __C.SHOW_UPSELL;
  var UPSELL_TITLE = __C.UPSELL_TITLE;
  var SHOW_PREFOOTER = __C.SHOW_PREFOOTER;
  var PREFOOTER_SUBTOTAL_LABEL = __C.PREFOOTER_SUBTOTAL_LABEL;
  var PREFOOTER_SHIPPING_LABEL = __C.PREFOOTER_SHIPPING_LABEL;
  var SHOW_PREFOOTER_INSTALL = __C.SHOW_PREFOOTER_INSTALL;
  var PREFOOTER_INSTALL_LABEL = __C.PREFOOTER_INSTALL_LABEL;
  var PREFOOTER_INSTALL_OPTIONS = __C.PREFOOTER_INSTALL_OPTIONS;
  var EMPTY_PRODUCTS_TITLE = __C.EMPTY_PRODUCTS_TITLE;
  var EMPTY_PRODUCTS = __C.EMPTY_PRODUCTS;
  var UPSELL_PRODUCTS = __C.UPSELL_PRODUCTS;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function escapeHtml(text) {
    var d = document.createElement('div');
    d.textContent = text || '';
    return d.innerHTML;
  }

  /* ── Dates / jours de livraison ── */
  function getDeliveryDates() {
    var now = new Date();
    var DAY = 86400000;
    if (TIMELINE_DATE_FORMAT === 'days') {
      /* Affichage en jours : "1j" / "1 - 2j" */
      function fmtDays(min, max) {
        /* 16/09/2026, maquette validee : « 1 à 2 jours » plutot que « 1 - 2 j » */
        return min === max ? min + ' jour' + (min > 1 ? 's' : '') : min + ' à ' + max + ' jours';
      }
      return {
        today:     'Aujourd\'hui',
        shipped:   fmtDays(SHIPPED_MIN, SHIPPED_MAX),
        delivered: fmtDays(DELIVERED_MIN, DELIVERED_MAX)
      };
    } else {
      /* Affichage en date : jj/mm */
      function fmt(d) { return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
      return {
        today:     fmt(now),
        shipped:   fmt(new Date(now.getTime() + SHIPPED_MIN * DAY)) + ' - ' + fmt(new Date(now.getTime() + SHIPPED_MAX * DAY)),
        delivered: fmt(new Date(now.getTime() + DELIVERED_MIN * DAY)) + ' - ' + fmt(new Date(now.getTime() + DELIVERED_MAX * DAY))
      };
    }
  }

  /* 02/09 - VERROU DE DEFILEMENT. body{overflow:hidden} seul ne verrouille PAS
     un telephone : l'element qui defile est <html>, pas <body>. La page continuait
     donc a defiler derriere le tiroir, ce qui donne l'impression que le telephone
     bugue. On verrouille les deux. */
  /* 02/11 23h (Lancelot : « je retire un produit, je le remets, le panier s'ouvre direct, j'ai même pas l'animation ») :
     la classe active était posée au milieu du gros travail du rendu (observateurs du skin, des avis, du prix) ;
     la glissade de 0,38 s se jouait pendant que le téléphone était occupé, donc invisible. Maintenant : position
     fermée lue d'abord, puis glissade lancée sur une image libre (2 images d'écran), filet à 150 ms si l'onglet
     ne dessine pas. RETOUR : remettre « if (d) d.classList.add('active'); » au début. */
  /* 03/11 01h (Lancelot : « un coup c'est comme ci, un coup c'est comme ça », police et éléments qui changent après rechargement).
     CAUSE : le tiroir est habillé par 4 feuilles de style chargées EN DIFFÉRÉ (almea-cart-skin.css, almea-panier-tiroir.css,
     almea-panier-nautiya.css, almea-panier-nautiya-patch.css ; sur la fiche, seulement après la grande photo) et par 2 scripts
     différés (almea-cart-skin.js, almea-panier-nautiya-patch.js, ce dernier « tard » sur la fiche), plus la police du tiroir (Jost)
     (affichée d'abord dans une police de secours). Selon le réseau, le tiroir s'ouvrait avant ou après eux : rendu différent.
     MAINTENANT : à la 1re ouverture on attend qu'ils soient TOUS là (on les demande tout de suite s'ils ne sont pas partis),
     plafond 3 s, rond de chargement pendant l'attente, puis un rendu complet : même tiroir à chaque fois.
     RETOUR : supprimer pret() et remettre l'ancien open() (historique git du Brain, avant le 03/11). */
  var PRET = null, PRET_FAIT = false;
  function pret() {
    if (PRET) return PRET;
    var att = [];
    [].forEach.call(document.querySelectorAll('link[data-almui]'), function (l) {
      var h = l.getAttribute('href') || l.getAttribute('data-almui-href') || '';
      if (!/panier|cart-skin/.test(h)) return;
      att.push(new Promise(function (ok) {
        var fin = function () { if (l.media !== 'all') l.media = 'all'; ok(); };
        if (l.getAttribute('href') && l.sheet) { fin(); return; }
        l.addEventListener('load', fin); l.addEventListener('error', ok);
        if (!l.getAttribute('href')) { l.removeAttribute('data-almui-href'); l.setAttribute('href', h); }
      }));
    });
    var script = function (motif, global) {
      if (window[global]) return;
      [].forEach.call(document.querySelectorAll('script[data-alm-tot],script[data-alm-tard]'), function (x) {
        var a = x.hasAttribute('data-alm-tot') ? 'data-alm-tot' : 'data-alm-tard', u = x.getAttribute(a) || '';
        if (!motif.test(u)) return;
        var n = document.createElement('script'); n.src = u; n.async = true;
        x.parentNode.replaceChild(n, x); /* même geste que le chargeur différé de la page : il ne le chargera pas une 2e fois */
      });
      att.push(new Promise(function (ok) { var k = 0; (function v() { if (window[global] || ++k > 60) ok(); else setTimeout(v, 50); })(); }));
    };
    script(/almea-cart-skin/, '__ntycInit');
    script(/almea-panier-nautiya-patch/, '__almDecorerPanier');
    try { if (document.fonts && document.fonts.load) att.push(Promise.all([document.fonts.load('400 16px Jost'), document.fonts.load('600 16px Jost')])); } catch (e) {}
    PRET = Promise.race([Promise.all(att), new Promise(function (ok) { setTimeout(ok, 3000); })]).then(function () { PRET_FAIT = true; });
    return PRET;
  }

  function open() {
    var d = document.getElementById('mzc-drawer'), o = document.getElementById('mzc-overlay');
    if (o) o.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    if (!d || d.classList.contains('active')) return;
    var glisse = function () {
      if (d.classList.contains('active') || (o && !o.classList.contains('active'))) return;
      void d.offsetWidth;
      var fait = false, go = function () { if (fait) return; fait = true; d.classList.add('active'); };
      requestAnimationFrame(function () { requestAnimationFrame(go); });
      setTimeout(go, 150);
    };
    if (PRET_FAIT) { glisse(); return; }
    /* 1re ouverture : le tiroir glisse tout de suite avec un rond de chargement, le contenu n'apparaît qu'une fois complet */
    d.classList.add('almcz-attente');
    glisse();
    pret().then(function () { if (window.almPanierEcrit) window.almPanierEcrit(); /* lecture fraîche du panier (jamais une réponse gardée d'avant l'ajout) */ return fetchCart(); }).then(function () { d.classList.remove('almcz-attente'); }, function () { d.classList.remove('almcz-attente'); });
  }

  function close() {
    var d = document.getElementById('mzc-drawer'), o = document.getElementById('mzc-overlay');
    if (d) d.classList.remove('active');
    if (o) o.classList.remove('active');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function updateBadge(count) {
    var el = document.getElementById('mzc-count');
    if (el) el.textContent = '(' + count + ')';
    document.querySelectorAll('.cart-count-badge').forEach(function(b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });    /* 26/10 (Lancelot : « le panier doit se mettre à jour instantanément ») : la pastille du header (#mzBadge)
       n'était jamais touchée ici → après « Retirer », elle restait sur l'ancien nombre jusqu'à la page suivante. */
    var mb = document.getElementById('mzBadge');
    if (mb) { mb.textContent = count; mb.classList.toggle('visible', count > 0); }
    document.documentElement.classList.toggle('alm-cart-full', count > 0);
  }

  /* ─── RENDER ─── */
  /* 02/09 — STABILITE. Trois choses reglees ici :
     ① Les prix barres etaient re-telechargés a CHAQUE rendu (un appel reseau par
        article, meme pour un simple +1). Ils sont desormais gardes en memoire.
     ② render() rend une PROMESSE. Avant, add() ouvrait le tiroir sans attendre :
        mesure du 02/09, le tiroir s'ouvrait a 455 ms avec l'ANCIEN contenu et le
        contenu reel arrivait a 620 ms — d'ou le clignotement a l'ajout.
     ③ attendrePeinture() laisse les couches d'habillage (skin, bandeau de
        confiance, notes) se poser ET les images se decoder AVANT d'ouvrir.
     REVERSIBLE : revenir au bloc d'origine, garde dans sauvegardes/. */
  var PRIX_CACHE = {};
  function render(cart) {
    var promises = cart.items.map(function(item) {
      var cle = item.handle + ':' + item.variant_id;
      if (Object.prototype.hasOwnProperty.call(PRIX_CACHE, cle)) {
        item._compare_at_price = PRIX_CACHE[cle];
        return null;
      }
      return fetch('/products/' + item.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var v = p.variants.find(function(v) { return v.id === item.variant_id; });
          item._compare_at_price = v && v.compare_at_price ? v.compare_at_price : 0;
          PRIX_CACHE[cle] = item._compare_at_price;
        })
        .catch(function() { item._compare_at_price = 0; PRIX_CACHE[cle] = 0; });
    }).filter(Boolean);
    return Promise.all(promises).then(function() {
      renderWithPrices(cart);
      /* 02/09 — LE PRIX SAUTAIT DEUX FOIS. Mesure : le prix etait ecrit ici a
         459 ms, puis REECRIT a 1095 ms par la couche de decoration
         (snippets/almea-panier-nautiya-patch.liquid), qui attendait 70 ms puis
         refaisait SON PROPRE fetch('/cart.js'). Deux peintures a 0,6 s d'ecart.
         On a deja le panier a jour : on lui passe directement, dans la meme
         passe. Sa minuterie verra ensuite que rien n'a change et ne fera rien. */
      try { if (window.__almDecorerPanier) window.__almDecorerPanier(cart); } catch (e) {}
      return attendrePeinture();
    });
  }

  /* Attend que le contenu du tiroir soit REELLEMENT pret a l'affichage :
     deux images de rendu (le temps que les MutationObserver du skin et du bandeau
     aient repasse), puis le decodage des images, plafonne a 320 ms pour ne jamais
     bloquer si une image tarde. */
  function attendrePeinture() {
    /* 02/09 — FILET OBLIGATOIRE : requestAnimationFrame ne se declenche PAS quand
       l'onglet passe en arriere-plan ou que le navigateur bride le rendu. Sans ce
       filet, le tiroir ne s'ouvrirait jamais dans ces cas-la. On plafonne donc
       l'attente a 600 ms avec un setTimeout, qui lui se declenche toujours. */
    var attente = new Promise(function(fini) {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          var d = document.getElementById('mzc-drawer');
          var imgs = d ? [].slice.call(d.querySelectorAll('img')) : [];
          var decodes = imgs.map(function(i) {
            try { return i.decode ? i.decode().catch(function(){}) : Promise.resolve(); }
            catch (e) { return Promise.resolve(); }
          });
          var plafond = new Promise(function(r) { setTimeout(r, 320); });
          Promise.race([Promise.all(decodes), plafond]).then(function() {
            requestAnimationFrame(function() { fini(); });
          });
        });
      });
    });
    var secours = new Promise(function(fini) { setTimeout(fini, 600); });
    return Promise.race([attente, secours]);
  }

  /* ── Build a single review card HTML ── */
  function buildReviewCard(rv, starsColor) {
    var starsHtml = '';
    for (var s = 1; s <= 5; s++) {
      starsHtml += '<svg viewBox="0 0 24 24" fill="' + (s <= rv.stars ? starsColor : '#e5e7eb') + '"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }

    var avatarHtml;
    var borderClass = REVIEW_AVATAR_BORDER ? ' mzc-review-avatar-border' : '';
    if (rv.image) {
      avatarHtml = '<div class="mzc-review-avatar-wrap' + borderClass + '"><img class="mzc-review-avatar" src="' + rv.image + '" alt="' + escapeHtml(rv.author) + '" loading="lazy" decoding="async"></div>';
    } else {
      var initials = (rv.author || '?').charAt(0).toUpperCase();
      avatarHtml = '<div class="mzc-review-avatar-wrap' + borderClass + '"><div class="mzc-review-avatar-placeholder">' + initials + '</div></div>';
    }

    return '<div class="mzc-review">'
      + '<span class="mzc-review-quote-open">"</span>'
      + '<div class="mzc-review-stars">' + starsHtml + '</div>'
      + '<div class="mzc-review-title">' + escapeHtml(rv.title) + '</div>'
      + '<div class="mzc-review-text">' + escapeHtml(rv.text) + '</div>'
      + '<div class="mzc-review-author-row">'
      + avatarHtml
      + '<div class="mzc-review-author-info"><span class="mzc-review-author-name">' + escapeHtml(rv.author) + '</span><span class="mzc-review-badge">✓ Verifizierte Bewertung</span></div>'
      + '</div>'
      + '<span class="mzc-review-quote-close">"</span>'
      + '</div>';
  }

  /* 02/09 — La zone qui defile (.mzc-content) est A L'INTERIEUR du HTML remplace :
     chaque rendu la recreait donc a zero et le tiroir remontait tout en haut des
     qu'on touchait a une quantite. On repose la position de defilement. */
  /* ══════════════════════════════════════════════════════════════════════
     02/09 — LE PANIER NE SE RECONSTRUIT PLUS, IL SE MET A JOUR.
     Avant : chaque clic sur + ou - remplacait TOUT le HTML du tiroir. D'ou ce que
     Lancelot voyait : la ligne de variante (« Couleur / Noyer »), le prix et la
     pastille « Economisez » disparaissaient puis revenaient, les vignettes se
     rechargeaient, la liste remontait en haut, et les couches d'habillage devaient
     tout refaire. Desormais on construit le nouveau HTML a cote puis on FUSIONNE :
     seuls les textes et attributs qui ont REELLEMENT change sont ecrits. Passer de
     1 a 2 articles n'insere que la nouvelle ligne. Rien d'autre ne bouge.
     REVERSIBLE : remplacer le corps de peindreCorps par `body.innerHTML = html`.
     ══════════════════════════════════════════════════════════════════════ */
  function memeIdentite(a, b) {
    if (a.nodeType !== b.nodeType) return false;
    if (a.nodeType !== 1) return true;
    if (a.nodeName !== b.nodeName) return false;
    var ka = a.getAttribute('data-key'), kb = b.getAttribute('data-key');
    if (ka || kb) return ka === kb;
    if (a.id || b.id) return a.id === b.id;
    return true;
  }

  /* Un bloc ENTIER ajoute par une couche d'habillage (bandeau de confiance, panneau
     d'aide, vignettes et carrousel du skin). Il n'existe pas dans notre HTML : on le
     laisse strictement tranquille, sinon on le supprime et la couche le recree —
     c'est exactement ce qui faisait clignoter le tiroir. */
  function blocEtranger(n) {
    if (!n || n.nodeType !== 1) return false;
    var c = (typeof n.className === 'string') ? n.className : '';
    /* 02/09 (2e passe) — LE PRIX QUI CLIGNOTE. Le bloc de prix enrichi
       (.alm-unit / .alm-line-now / .alm-line-was / .alm-save « Economisez ») est
       CREE par snippets/almea-panier-nautiya-patch.liquid : il n'existe pas dans
       le HTML que cette section genere. La fusion le voyait donc comme un noeud
       en trop et le supprimait ; la couche le recreait juste apres. D'ou le prix
       qui disparait puis reapparait a chaque +1. Tous les blocs prefixes alm- et
       ntyc- sont desormais intouchables. */
    return /(^|\s)(alm-|ntyc-)/.test(c);
  }

  /* Zone reconstruite par le skin a partir du texte brut (la ligne de variante :
     « Couleur / Noyer », plus la note qu'on y ajoute). Elle ne change jamais quand
     on modifie une quantite : on n'y touche pas du tout. */
  function zoneGelee(n) {
    if (!n || n.nodeType !== 1) return false;
    var c = (typeof n.className === 'string') ? n.className : '';
    return /(^|\s)(mzc-item-variant|mzc-item-note)(\s|$)/.test(c);
  }

  function signature(n) {
    if (n.nodeType !== 1) return '#' + n.nodeType;
    var c = (typeof n.className === 'string') ? n.className.split(' ')[0] : '';
    var k = n.getAttribute('data-key');
    /* ATTENTION : Shopify REGENERE la cle d'une ligne de panier a chaque
       changement de quantite (53425258004808:5c16b2… devient 53425258004808:c2ff42…).
       Comparer la cle entiere revient donc a dire « ce n'est plus le meme article »
       et a recreer la ligne : c'est ce qui la faisait sauter. On ne garde que
       l'identifiant de variante, lui stable. */
    if (k) k = k.split(':')[0];
    return n.nodeName + '|' + (k || n.id || c);
  }

  function fusionner(vieux, neuf) {
    if (vieux.nodeType === 3 || vieux.nodeType === 8) {
      if (vieux.nodeValue !== neuf.nodeValue) vieux.nodeValue = neuf.nodeValue;
      return;
    }
    if (vieux.nodeType !== 1) return;
    if (zoneGelee(vieux)) return;

    var an = neuf.attributes, i, at;
    for (i = 0; i < an.length; i++) {
      at = an[i];
      if (vieux.getAttribute(at.name) !== at.value) vieux.setAttribute(at.name, at.value);
    }
    var av = vieux.attributes;
    for (i = av.length - 1; i >= 0; i--) {
      var nom = av[i].name;
      if (!neuf.hasAttribute(nom) && nom !== 'style' && nom.indexOf('data-ntyc') !== 0 && nom.indexOf('data-alm') !== 0 && nom.indexOf('data-mzc') !== 0) {
        vieux.removeAttribute(nom);
      }
    }

    /* Une image dont la source ne change pas ne doit JAMAIS etre recreee :
       c'est ce qui faisait clignoter les vignettes du panier. */
    if (vieux.nodeName === 'IMG') return;

    /* APPARIEMENT PAR SIGNATURE, pas par position. Les couches d'habillage
       inserent leurs propres blocs dans le tiroir : un appariement par index
       decalait tout d'un cran et faisait remplacer la liste entiere — donc
       vignettes rechargees et lignes qui sautent. On retrouve chaque noeud par
       son identite (cle d'article, id, ou premiere classe), on le DEPLACE au
       bon endroit sans le detruire, et on garde les blocs etrangers a la fin. */
    var restants = [], k, j;
    for (k = 0; k < vieux.childNodes.length; k++) restants.push(vieux.childNodes[k]);
    var ordre = [];
    for (k = 0; k < neuf.childNodes.length; k++) {
      var b = neuf.childNodes[k], sig = signature(b), trouve = null;
      for (j = 0; j < restants.length; j++) {
        if (restants[j] && signature(restants[j]) === sig) { trouve = restants[j]; restants[j] = null; break; }
      }
      if (trouve) { fusionner(trouve, b); ordre.push(trouve); }
      else ordre.push(b.cloneNode(true));
    }
    for (j = 0; j < restants.length; j++) {
      if (restants[j] && blocEtranger(restants[j])) ordre.push(restants[j]);
    }
    for (k = 0; k < ordre.length; k++) {
      if (vieux.childNodes[k] !== ordre[k]) vieux.insertBefore(ordre[k], vieux.childNodes[k] || null);
    }
    while (vieux.childNodes.length > ordre.length) vieux.removeChild(vieux.lastChild);
  }

  /* ══════════════════════════════════════════════════════════════════════
     02/09 — TRANSITION DOUCE SUR LES CHIFFRES QUI CHANGENT.
     Demande de Lancelot : « je voudrais que ce soit smooth, pas que ça disparaisse
     puis réapparaisse ». Une fois le clignotement supprime, un chiffre change d'un
     coup — correct, mais sec. On ecoute donc UNIQUEMENT les changements de texte
     dans le tiroir et on pose une classe qui joue un fondu de 260 ms. On n'observe
     que characterData et on n'ecrit qu'un attribut : aucune boucle possible.
     Le compte a rebours est exclu, sinon il pulserait chaque seconde.
     ══════════════════════════════════════════════════════════════════════ */
  (function douceur(){
    var d = document.getElementById('mzc-drawer');
    if (!d) { setTimeout(douceur, 400); return; }
    if (d.dataset.almDouceur) return;
    d.dataset.almDouceur = '1';
    var minuteurs = new WeakMap();
    try {
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i], el;
          if (m.type === 'characterData') {
            el = m.target.parentNode;
          } else {
            /* Un chiffre remplace par textContent = une mutation childList, pas
               characterData. C'est le cas de .alm-line-now et de .alm-save, ecrits
               par la couche de prix. On ne retient que les elements SANS enfant
               element (des feuilles de texte) : jamais un conteneur. */
            el = m.target;
            if (!el || el.nodeType !== 1 || el.children.length) continue;
          }
          if (!el || el.nodeType !== 1) continue;
          if (el.closest && el.closest('.mzc-timer, #mzc-timer-wrap')) continue;
          var t = minuteurs.get(el);
          if (t) clearTimeout(t);
          el.classList.remove('alm-maj');
          void el.offsetWidth;
          el.classList.add('alm-maj');
          minuteurs.set(el, setTimeout(function(e){ return function(){ e.classList.remove('alm-maj'); }; }(el), 320));
        }
      }).observe(d, { characterData: true, childList: true, subtree: true });
    } catch (e) {}
  })();

  function peindreCorps(body, html) {
    var ancien = body.querySelector('.mzc-content');
    var tampon = document.createElement('div');
    tampon.innerHTML = html;
    var neuf = tampon.querySelector('.mzc-content');
    /* Bascule de structure (panier vide <-> panier plein) : remplacement franc. */
    if (!ancien || !neuf) { body.innerHTML = html; return; }
    var haut = ancien.scrollTop;
    try { fusionner(ancien, neuf); }
    catch (e) { body.innerHTML = html; return; }
    if (haut) ancien.scrollTop = haut;
  }

  /* 28/09/2026 — best-sellers du panier vide */
  var ALM_BEST = null, ALM_BEST_ATTENTE = [];
  function almBestCharger(cb) {
    if (ALM_BEST) { cb(ALM_BEST); return; }
    ALM_BEST_ATTENTE.push(cb);
    if (ALM_BEST_ATTENTE.length > 1) return;
    fetch('/collections/all?sort_by=best-selling&view=almbest', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { var l = []; try { l = JSON.parse(t); } catch (e) { l = []; } return l; })
      .catch(function () { return []; })
      .then(function (l) {
        ALM_BEST = (l || []).filter(function (x) { return x && x.h && x.n; });
        var a = ALM_BEST_ATTENTE; ALM_BEST_ATTENTE = [];
        a.forEach(function (f) { try { f(ALM_BEST); } catch (e) {} });
      });
  }
  function almEuro(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
  function almBestHtml(l) {
    var h = '<div class="mzc-best-tete"><p class="mzc-best-titre">Unsere Bestseller</p>'
      + '<span class="mzc-best-fl"><button type="button" aria-label="Zurück" onclick="MzCartV2.bestDefiler(-1)">&#8249;</button>'
      + '<button type="button" aria-label="Suivant" onclick="MzCartV2.bestDefiler(1)">&#8250;</button></span></div>'
      + '<div class="mzc-best-rail" id="mzc-best-rail">';
    for (var i = 0; i < l.length; i++) {
      var x = l[i], url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(x.h); /* 27/10 : langue du client devant le lien (DE/UK) */
      var pct = x.c > x.p ? Math.round((x.c - x.p) / x.c * 100) : 0;
      h += '<div class="mzc-best-carte">'
        + '<a class="mzc-best-img" href="' + url + '">' + (pct ? '<span class="mzc-best-pct">\u2212' + pct + '\u00a0%</span>' : '') + (x.i ? '<img src="' + escapeHtml(x.i) + '" alt="' + escapeHtml(x.n) + '" loading="lazy" decoding="async" width="400" height="500">' : '') + '</a>'
        + '<a class="mzc-best-nom" href="' + url + '">' + escapeHtml(x.n) + '</a>'
        + '<span class="mzc-best-prix">' + almEuro(x.p) + (x.c > x.p ? ' <s>' + almEuro(x.c) + '</s>' : '') + '</span>'
        /* 10/10 (Lancelot) : un seul bouton, « Ajouter au panier », sur toutes les cartes (variante par défaut) */
        + (x.v ? '<button type="button" class="mzc-best-add" onclick="MzCartV2.add(' + parseInt(x.v, 10) + ',1)">In den Warenkorb</button>'
               : '<a class="mzc-best-add" href="' + url + '">In den Warenkorb</a>')
        + '</div>';
    }
    return h + '</div>';
  }
  function bestDefiler(d) {
    var r = document.getElementById('mzc-best-rail'); if (!r) return;
    var c = r.querySelector('.mzc-best-carte'); var w = c ? c.getBoundingClientRect().width + 12 : 180;
    r.scrollBy({ left: d * w, behavior: 'smooth' });
  }
  (function () {
    var st = document.createElement('style');
    st.textContent = '#mzc-drawer .mzc-best{margin:4px 0 8px}'
      + '#mzc-drawer .mzc-best-tete{display:flex;align-items:center;justify-content:space-between;margin:0 0 12px}'
      + '#mzc-drawer .mzc-best-titre{margin:0;font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:#141210}'
      + '#mzc-drawer .mzc-best-fl{display:flex;gap:6px}'
      + '#mzc-drawer .mzc-best-fl button{width:30px;height:30px;border-radius:50%;border:1px solid #e3ddd4;background:#fff;color:#141210;font-size:18px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0 0 2px}'
      + '#mzc-drawer .mzc-best-fl button:hover{border-color:#141210}'
      + '#mzc-drawer .mzc-best-rail{display:flex;gap:12px;overflow-x:auto;overscroll-behavior-x:contain;touch-action:pan-x pan-y;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding:0 0 4px;margin:0 -2px}'
      + '#mzc-drawer #ntyc-empty .ntyc-empty-msg{padding:28px 10px 22px !important}'
      + '#mzc-drawer .mzc-best-rail::-webkit-scrollbar{display:none}'
      + '#mzc-drawer .mzc-best-carte{flex:0 0 calc(50% - 22px);min-width:0;scroll-snap-align:start;display:flex;flex-direction:column;gap:6px}'
      + '#mzc-drawer .mzc-best-img{display:block;aspect-ratio:1/1;border-radius:10px;overflow:hidden;background:#f3efe9}'
      + '#mzc-drawer .mzc-best-img img{width:100%;height:100%;object-fit:cover;display:block}'
      + '#mzc-drawer .mzc-best-nom{font-family:inherit;font-size:13px;font-weight:500;line-height:1.3;color:#141210;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.6em}'
      + '#mzc-drawer .mzc-best-prix{font-family:inherit;font-size:13px;font-weight:600;color:#141210}'
      + '#mzc-drawer .mzc-best-prix s{font-weight:400;color:#9a948d;margin-left:4px;font-size:12px}'
      + '#mzc-drawer .mzc-best-add{margin-top:auto;display:flex;align-items:center;justify-content:center;height:36px;border-radius:999px;border:0;background:#141210;color:#fff !important;font-family:inherit;font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;text-decoration:none;cursor:pointer}'
      + '#mzc-drawer .mzc-best-add:hover{opacity:.85}'
      /* 10/10 (Lancelot : « fais des belles cartes ») : cartes carrées, prix rouge, pastille −%, bouton pleine largeur */
      + '#mzc-drawer .mzc-empty-top{text-align:center;padding:8px 0 4px}'
      + '#mzc-drawer .mzc-empty-t{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif;font-size:21px;font-weight:800;letter-spacing:-.01em;color:#141414;margin:0 0 6px}'
      + '#mzc-drawer .mzc-empty-s{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif;font-size:13.5px;color:#6a645c;margin:0 0 22px}'
      + '#mzc-drawer .mzc-best-titre{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif !important;font-weight:800 !important}'
      + '#mzc-drawer .mzc-best-fl button{border-radius:0 !important}'
      + '#mzc-drawer .mzc-best-carte{gap:8px !important;background:#fff;border:1px solid #ECE7DE;padding:0 0 10px}'
      + '#mzc-drawer .mzc-best-img{position:relative;border-radius:0 !important;aspect-ratio:1/1}'
      + '#mzc-drawer .mzc-best-pct{position:absolute;top:8px;left:8px;z-index:1;background:#C8372D;color:#fff;font:700 11px/1 AlmArchivo,Arial,sans-serif;padding:4px 6px}'
      + '#mzc-drawer .mzc-best-nom{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif !important;font-size:15px !important;font-weight:800 !important;padding:0 10px}'
      + '#mzc-drawer .mzc-best-prix{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif !important;font-size:14px !important;font-weight:700 !important;color:#C8372D !important;padding:0 10px}'
      + '#mzc-drawer .mzc-best-prix s{color:#8a847c !important;font-weight:400 !important}'
      + '#mzc-drawer .mzc-best-add{margin:4px 10px 0 !important;height:40px !important;border-radius:0 !important;font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif !important;font-size:11.5px !important;font-weight:700 !important;letter-spacing:.06em !important;text-transform:uppercase !important;text-decoration:none !important;white-space:nowrap !important;font-size:10.5px !important;letter-spacing:.02em !important;padding:0 4px !important}'
      + '#mzc-drawer .mzc-best-nom{min-height:0 !important;margin:0 !important}'
      /* 10/10 (Lancelot) : panier vide : le message en haut, les best-sellers en bas du tiroir */
      + '#mzc-drawer #ntyc-empty{display:flex !important;flex-direction:column !important;min-height:calc(100dvh - 130px)}'
      + '#mzc-drawer #ntyc-empty > .mzc-best{margin-top:auto !important;padding-top:24px}'
      + '#mzc-drawer .ntyc-empty-title{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif !important;font-size:21px !important;font-weight:800 !important;letter-spacing:-.01em !important;color:#141414 !important}'
      + '#mzc-drawer .ntyc-empty-sub{font-family:AlmArchivo,Helvetica Neue,Arial,sans-serif !important;font-size:13.5px !important;color:#6a645c !important}';
    document.head.appendChild(st);
  })();

  function renderWithPrices(cart) {
    var body   = document.getElementById('mzc-body');
    var footer = document.getElementById('mzc-footer');
    if (!body) return;

    var totalQty = 0;
    for (var i = 0; i < cart.items.length; i++) totalQty += cart.items[i].quantity;
    updateBadge(totalQty);

    /* Panier vide */
    if (cart.item_count === 0) {
      if (footer) footer.style.display = 'none';
      var emptyHtml = '<div class="mzc-content">'
        + '<div class="mzc-empty-top">'
        + '<p class="mzc-empty-t">Ihr Warenkorb ist leer</p>'
        + '<p class="mzc-empty-s">Unsere Kunden beginnen oft mit einer dieser Leuchten.</p>'
        + '</div>';
      /* 28/09/2026 04h50 (Lancelot : « panier vide : un carrousel avec nos meilleurs produits ») :
         carrousel des best-sellers (données : templates/collection.almbest.liquid). L'ancienne liste
         (réglages du tiroir) ne sert plus que si les best-sellers n'ont pas pu être chargés. */
      emptyHtml += '<div class="mzc-best" id="mzc-best">' + (ALM_BEST && ALM_BEST.length ? almBestHtml(ALM_BEST) : '') + '</div>';
      var productsToShow = (ALM_BEST && !ALM_BEST.length) ? (EMPTY_PRODUCTS.length > 0 ? EMPTY_PRODUCTS : UPSELL_PRODUCTS) : [];
      if (!ALM_BEST) almBestCharger(function (l) {
        var z = document.getElementById('mzc-best');
        if (z && l.length) { z.innerHTML = almBestHtml(l); }
        else if (z && !l.length) { try { renderWithPrices({ items: [], item_count: 0 }); } catch (e) {} }
      });
      if (productsToShow.length > 0) {
        emptyHtml += '<p style="font-family:Poppins,sans-serif;font-size:13px;font-weight:700;color:var(--mzc-title);margin:0 0 14px;">' + escapeHtml(EMPTY_PRODUCTS_TITLE) + '</p>';
        for (var u = 0; u < productsToShow.length; u++) {
          var up = productsToShow[u];
          if (!up.name) continue;
          var addAction = up.vid
            ? 'event.stopPropagation();MzCartV2.add(' + up.vid + ',1)'
            : 'event.stopPropagation();MzCartV2.addByHandle(\'' + escapeHtml(up.handle) + '\',1)';
          emptyHtml += '<div class="mzc-empty-row" onclick="window.location.href=\'' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + escapeHtml(up.handle) + '\'">'
            + '<div class="mzc-empty-row-img">'
            + (up.image ? '<img src="' + up.image + '" alt="' + escapeHtml(up.name) + '" loading="lazy" decoding="async">' : '')
            + '</div>'
            + '<div class="mzc-empty-row-info">'
            + '<span class="mzc-empty-row-name">' + escapeHtml(up.name) + '</span>'
            + (up.price ? '<span class="mzc-empty-row-price">' + escapeHtml(up.price) + '</span>' : '')
            + '</div>'
            + '<button type="button" class="mzc-empty-row-add" onclick="' + addAction + '" aria-label="In den Warenkorb">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
            + '</button>'
            + '</div>';
        }
      }
      emptyHtml += '</div>';
      peindreCorps(body, emptyHtml);
      return;
    }

    if (footer) footer.style.display = 'block';
    var dates = getDeliveryDates();
    var html = '<div class="mzc-content">';

    /* ── Timer ── */
    if (SHOW_TIMER) {
      html += '<div class="mzc-timer" id="mzc-timer-wrap">'
        + '<div class="mzc-timer-left">'
        + '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
        + '<div class="mzc-timer-texts">'
        + '<span class="mzc-timer-label">' + escapeHtml(TIMER_LABEL) + '</span>'
        + '<span class="mzc-timer-urgency">' + escapeHtml(TIMER_URGENCY) + '</span>'
        + '</div></div>'
        + '<div class="mzc-timer-digits">'
        + '<span class="mzc-timer-block" id="mzc-timer-min">--</span>'
        + '<span class="mzc-timer-sep">:</span>'
        + '<span class="mzc-timer-block" id="mzc-timer-sec">--</span>'
        + '</div></div>';
    }

    /* ── 29/10 (Lancelot) : barre « livraison offerte débloquée » (livraison toujours offerte : barre pleine, rien d'inventé) ── */
    /* 03/11 (Lancelot, maquette A validée) : UN seul bloc vert en haut : « Livraison offerte débloquée » + dessous « Chez vous entre le X et le Y » avec le drapeau du pays de livraison (drapeaux posés par sections/z-paniermasazen, window.__almczFlags). Dates = MÊME règle que la fiche (sections/z-pageproduirgong : aujourd'hui + 7 et + 10 jours). La ligne « Chez vous avant le … » plus bas est retirée (plus de doublon). RETOUR : remettre la ligne d'origine et le bloc Timeline (historique git du Brain, avant le 03/11). */
    var almPlus = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
    var almA = almPlus(7), almB = almPlus(10), memeMois = almA.getMonth() === almB.getMonth();
    var almJ = function (d, m) { if (!m) { return d.getDate() + '.'; } return d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' }); }; /* « zwischen dem 10. und 13. November » */
    var almPays = document.documentElement.classList.contains('alm-be') ? 'BE' : (window.__almczPays || '');
    var almFlag = (window.__almczFlags || {})[almPays] || '';
    var almDate = '<span class="mzc-ship-date">' + (almFlag ? '<i class="mzc-ship-flag" aria-hidden="true">' + almFlag + '</i>' : '') + '<span>' + 'Bei Ihnen zwischen dem <b>' + almJ(almA, !memeMois) + '</b> und <b>' + almJ(almB, true) + '</b>' + '</span></span>';
    html += '<div class="mzc-ship" role="status"><div class="mzc-ship-top"><span class="mzc-ship-ok" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span><span class="mzc-ship-txt"><strong>Kostenloser Versand freigeschaltet</strong></span></div><div class="mzc-ship-bar" aria-hidden="true"><span class="mzc-ship-fill"></span><span class="mzc-ship-truck"><svg viewBox="0 0 24 24"><path d="M2.5 7.5h11v8.5h-11zM13.5 10.5h4l3 3v2.5h-7"/><circle cx="6.5" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg></span></div></div>';
    /* 03/11 16h30 (Lancelot : « je veux séparer livraison offerte et chez vous entre ») : la date sort du bloc vert, sur sa propre ligne juste dessous. */
    html += '<div class="mzc-ship-quand">' + almDate + '</div>';

    /* ── Items ── */
    html += '<div class="mzc-items">';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      /* 03/09 - la ligne de variante porte le NOM de l'option (« Finition du bois : Noyer »),
         pas seulement la valeur : le skin nautiya-cart-skin ajoutait « Taille : » devant
         toute valeur qui n'etait pas une couleur connue (« Taille : Noyer »). */
      var variantTxt = '';
      if (item.options_with_values && item.options_with_values.length) {
        var partsV = [];
        for (var ov = 0; ov < item.options_with_values.length; ov++) {
          var o = item.options_with_values[ov];
          if (!o || !o.value || o.value === 'Default Title') continue;
          partsV.push((o.name && o.name !== 'Title' ? o.name + ' : ' : '') + o.value);
        }
        variantTxt = partsV.join(' / ');
      } else if (item.variant_title && item.variant_title !== 'Default Title') { variantTxt = item.variant_title; }
      var variantHtml = variantTxt ? '<div class="mzc-item-variant">' + escapeHtml(variantTxt) + '</div>' : '';

      var compareTotal = (item._compare_at_price || 0) * item.quantity;
      var priceHtml;
      if (compareTotal > item.final_line_price) {
        priceHtml = '<div class="mzc-item-price">'
          + '<span style="text-decoration:line-through;color:var(--mzc-text);font-weight:400;margin-right:6px;font-size:13px;">' + formatMoney(compareTotal) + '</span>'
          + '<span>' + formatMoney(item.final_line_price) + '</span></div>';
      } else if (item.original_line_price > item.final_line_price) {
        priceHtml = '<div class="mzc-item-price">'
          + '<span style="text-decoration:line-through;color:var(--mzc-text);font-weight:400;margin-right:6px;font-size:13px;">' + formatMoney(item.original_line_price) + '</span>'
          + '<span>' + formatMoney(item.final_line_price) + '</span></div>';
      } else {
        priceHtml = '<div class="mzc-item-price">' + formatMoney(item.final_line_price) + '</div>';
      }

      html += '<div class="mzc-item" data-key="' + item.key + '">'
        + '<a href="' + item.url + '" class="mzc-item-img"><img src="' + (item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '') + '" alt="" width="80" height="80" loading="' + (i < 4 ? 'eager' : 'lazy') + '" decoding="async"></a>' /* 02/11 23h30 (Lancelot : produit sans photo) : 500 px comme le reste du tiroir (plus de changement d'image en route), 4 premières chargées tout de suite */
        + '<div class="mzc-item-info">'
        + '<a href="' + item.url + '" class="mzc-item-name">' + ((window.__almPN || {})[item.handle] ? '<span class="mzc-pn">' + escapeHtml(window.__almPN[item.handle]) + '</span><span class="mzc-pt">' + escapeHtml(item.product_title) + '</span>' : escapeHtml(item.product_title)) + '</a>'
        + variantHtml + priceHtml
        + '<div class="mzc-item-qty">'
        + '<button type="button" class="mzc-qty-btn" aria-label="Eins entfernen" onclick="MzCartV2.step(\'' + item.key + '\',-1)">−</button>'
        + '<span class="mzc-qty-val">' + item.quantity + '</span>'
        + '<button type="button" class="mzc-qty-btn" aria-label="Eins hinzufügen" onclick="MzCartV2.step(\'' + item.key + '\',1)">+</button>'
        + '</div></div>'
        + '<button type="button" class="mzc-item-remove" onclick="MzCartV2.update(\'' + item.key + '\',0)" aria-label="Entfernen">'
        + '<svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12"/></svg></button>'
        + '</div>';
    }
    html += '</div>';

    /* 03/11 (Lancelot, maquette A) : « Une 2e <nom>, pour faire la paire ? −10 % sur la 2e · prix » + Ajouter (1 unité de plus de la même variante),
       pour le 1er article s'il est une applique ou une suspension et pris en 1 exemplaire. AUCUNE remise Shopify n'existe encore :
       bloc COUPÉ par défaut (réglage « Bloc paire » de la section), visible seulement si window.__almczPaire (réglage coché, ou ?paire=1 sur un brouillon). */
    /* 03/11 00h41 (Lancelot valide) : la remise est la remise automatique existante « Pack de 2 : 5 % » (5 % sur chaque unité = −10 % sur la 2e). Prix affiché = calcul de Shopify, arrondi unité par unité (5 % tronqué au centime sur chaque unité) : prix de la 2e = prix − 2 × 5 % arrondi, pile ce que le client paiera. */
    /* 03/11 01h (Lancelot) : dès qu'il y a UNE applique ou suspension en 1 exemplaire (pas seulement en 1re ligne), types traduits DE / UK compris */
    var it0 = null;
    for (var ip = 0; ip < cart.items.length && !it0; ip++) { if (cart.items[ip].quantity === 1 && /applique|suspension|wand|h(ä|ae)nge|pendel|wall|sconce|pendant/i.test(cart.items[ip].product_type || '')) it0 = cart.items[ip]; }
    if (window.__almczPaire && it0) {
      var pn = (window.__almPN || {})[it0.handle] || '';
      html += '<div class="almcz-paire">'
        + (it0.image ? '<img src="' + it0.image + (it0.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="52" height="64" decoding="async">' : '')
        + '<div class="almcz-paire__t"><b>' + escapeHtml((pn ? 'Eine zweite ' + pn : (/suspension|h(ä|ae)nge|pendel|pendant/i.test(it0.product_type || '') ? 'Eine zweite Pendelleuchte' : 'Eine zweite Wandleuchte')) + ', als Paar?') + '</b><span>' + '−10 % auf die zweite · <b>' + formatMoney(it0.price - 2 * Math.floor(it0.price * 5 / 100)) + '</b></span></div>'
        + '<button type="button" class="almcz-paire__b" aria-label="Eine zweite hinzufügen" onclick="MzCartV2.step(\'' + it0.key + '\',1)">Hinzufügen</button>'
        + '</div>';
    }

    /* 03/11 01h : l'avis client (photo envoyée par le client, modèle #almcz-tpl de la section) fait partie du MÊME rendu : il ne peut plus apparaître en retard ni clignoter */
    var almAvis = document.getElementById('almcz-tpl');
    if (almAvis) html += almAvis.innerHTML;

    /* ── Vous aimerez aussi ── */
    if (SHOW_UPSELL && UPSELL_PRODUCTS.length > 0) {
      html += '<div class="mzc-upsell">'
        + '<h3 class="mzc-upsell-title">'
        + '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + escapeHtml(UPSELL_TITLE)
        + '</h3>'
        + '<div class="mzc-upsell-list">';

      for (var u = 0; u < UPSELL_PRODUCTS.length; u++) {
        var up = UPSELL_PRODUCTS[u];
        if (!up.name) continue;
        var imgHtml = up.image
          ? '<img src="' + up.image + '" alt="' + escapeHtml(up.name) + '" loading="lazy" decoding="async">'
          : '<div style="width:100%;height:100%;background:var(--mzc-border);"></div>';
        var addAction = up.vid
          ? 'MzCartV2.add(' + up.vid + ',1)'
          : 'MzCartV2.addByHandle(\'' + escapeHtml(up.handle) + '\',1)';

        /* Paiement en plusieurs fois par produit */
        var installHtml = (up.showInstall && up.installText && up.installText !== '-')
          ? '<span class="mzc-upsell-installment">' + escapeHtml(up.installText) + '</span>'
          : '';

        html += '<div class="mzc-upsell-item">'
          + '<div class="mzc-upsell-img">' + imgHtml + '</div>'
          + '<div class="mzc-upsell-info">'
          + '<span class="mzc-upsell-name">' + escapeHtml(up.name) + '</span>'
          + '<div class="mzc-upsell-price-row">'
          + (up.price ? '<span class="mzc-upsell-price">' + escapeHtml(up.price) + '</span>' : '')
          + installHtml
          + '</div>'
          + '</div>'
          + '<button type="button" class="mzc-upsell-add" onclick="' + addAction + '" aria-label="Hinzufügen">'
          + '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
          + '</button>'
          + '</div>';
      }

      html += '</div></div>';
    }

    /* ── Summary (bloc coupon + lignes détail) ── */
    if (SHOW_SUMMARY) {
      html += '<div class="mzc-summary">';

      /* Champ code promo */
      html += '<div class="mzc-coupon-wrap">'
        + '<div class="mzc-coupon-row">'
        + '<input type="text" class="mzc-coupon-input" id="mzc-coupon-input" placeholder="Code promo" maxlength="50" onkeydown="if(event.key===\'Enter\')MzCartV2.applyCoupon()">'
        + '<button type="button" class="mzc-coupon-btn" id="mzc-coupon-btn" onclick="MzCartV2.applyCoupon()">Anwenden</button>'
        + '</div>'
        + '<div class="mzc-coupon-msg" id="mzc-coupon-msg"></div>'
        + '</div>';

      var subtotalBeforeDiscount = cart.total_price + (cart.total_discount || 0);
      html += '<div class="mzc-summary-row"><span>' + SUBTOTAL_TEXT + '</span><span>' + formatMoney(subtotalBeforeDiscount) + '</span></div>';

      /* Réductions */
      var allDiscounts = [];
      var seen = {};
      var cartLevel = cart.cart_level_discount_applications || [];
      for (var d = 0; d < cartLevel.length; d++) {
        var disc = cartLevel[d];
        var key = (disc.title || '').toUpperCase();
        if (!seen[key]) { seen[key] = true; allDiscounts.push({ title: disc.title, amount: disc.total_allocated_amount || 0 }); }
      }
      var lineLevel = cart.discount_applications || [];
      for (var d = 0; d < lineLevel.length; d++) {
        var disc = lineLevel[d];
        var key = (disc.title || '').toUpperCase();
        if (!seen[key]) {
          var totalAllocated = 0;
          for (var ii = 0; ii < cart.items.length; ii++) {
            var allocations = cart.items[ii].discount_allocations || [];
            for (var aa = 0; aa < allocations.length; aa++) {
              if (allocations[aa].discount_application_index === d) totalAllocated += allocations[aa].amount;
            }
          }
          if (totalAllocated > 0) { seen[key] = true; allDiscounts.push({ title: disc.title, amount: totalAllocated }); }
        }
      }
      if (allDiscounts.length === 0 && cart.total_discount > 0) {
        var fallbackTitle = null;
        try { if (window.Shopify && window.Shopify.discounts && window.Shopify.discounts.length) fallbackTitle = window.Shopify.discounts[0].code || null; } catch(e) {}
        try { var match = document.cookie.match(/discount_code=([^;]+)/); if (match) fallbackTitle = decodeURIComponent(match[1]); } catch(e) {}
        allDiscounts.push({ title: fallbackTitle, amount: cart.total_discount });
      }
      for (var d = 0; d < allDiscounts.length; d++) {
        if (allDiscounts[d].amount > 0) {
          var discTitle = allDiscounts[d].title ? escapeHtml(allDiscounts[d].title) : 'Rabatt angewendet';
          html += '<div class="mzc-discount">'
            + '<div class="mzc-discount-left"><svg viewBox="0 0 24 24"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
            + '<span class="mzc-discount-code">' + discTitle + '</span></div>'
            + '<div style="display:flex;align-items:center;gap:10px;">'
            + '<span class="mzc-discount-amount">−' + formatMoney(allDiscounts[d].amount) + '</span>'
            + '<button type="button" class="mzc-discount-remove" onclick="MzCartV2.removeDiscount()" aria-label="Rabatt entfernen"><svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12"/></svg></button>'
            + '</div></div>';
        }
      }

      html += '<div class="mzc-summary-row"><span>' + SHIPPING_TEXT + '</span><span class="free">' + SHIPPING_VALUE + '</span></div>';
      html += '<div class="mzc-summary-row total"><span>' + TOTAL_TEXT + '</span><span>' + formatMoney(cart.total_price) + '</span></div>';
      html += '</div>';
    }

    /* ── Timeline : 03/11 retirée, la date est dans le bloc vert du haut (voir mzc-ship) ── */

    /* ── Recap footer (TentBox style) — injecté dans le footer fixe ── */
    var recapEl = document.getElementById('mzc-footer-recap');
    if (SHOW_PREFOOTER && recapEl) {
      var rhtml = '<div class="mzc-footer-subtotal">'
        + '<span class="mzc-footer-subtotal-label">' + escapeHtml(PREFOOTER_SUBTOTAL_LABEL) + '</span>'
        + '<span class="mzc-footer-subtotal-amount">' + formatMoney(cart.total_price) + '</span>'
        + '</div>'
        + '<div class="mzc-footer-shipping">'
        + '<span class="mzc-footer-shipping-label">' + escapeHtml(PREFOOTER_SHIPPING_LABEL) + '</span>'
        + '<span class="mzc-footer-shipping-badge">Ohne Mindestwert</span>'
        + '</div>';
      if (SHOW_PREFOOTER_INSTALL && PREFOOTER_INSTALL_OPTIONS.length > 0) {
        rhtml += '<div class="mzc-installment-row">';
        rhtml += '<span class="mzc-installment-label">' + escapeHtml(PREFOOTER_INSTALL_LABEL) + '</span>';
        for (var p = 0; p < PREFOOTER_INSTALL_OPTIONS.length; p++) {
          if (PREFOOTER_INSTALL_OPTIONS[p] && PREFOOTER_INSTALL_OPTIONS[p] !== '-') {
            rhtml += '<span class="mzc-installment-option">'
              + '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>'
              + escapeHtml(PREFOOTER_INSTALL_OPTIONS[p])
              + '</span>';
          }
        }
        rhtml += '</div>';
      }
      recapEl.innerHTML = rhtml;
      recapEl.style.display = 'block';
    } else if (recapEl) {
      recapEl.style.display = 'none';
    }

    /* ── Avis client (slider ou simple) ── */
    if (SHOW_REVIEW && REVIEWS.length > 0) {
      if (REVIEW_SLIDER && REVIEWS.length > 1) {
        /* Slider multi-avis */
        html += '<div class="mzc-review-wrap" id="mzc-review-wrap">';
        /* Arrows */
        html += '<button type="button" class="mzc-review-arrow prev" onclick="MzCartV2.reviewSlide(-1)" aria-label="Zurück"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>';
        html += '<button type="button" class="mzc-review-arrow next" onclick="MzCartV2.reviewSlide(1)" aria-label="Suivant"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg></button>';
        /* Slides */
        html += '<div class="mzc-review-slider" id="mzc-review-slider">';
        for (var r = 0; r < REVIEWS.length; r++) {
          html += '<div class="mzc-review-slide">' + buildReviewCard(REVIEWS[r], REVIEW_STARS_COLOR) + '</div>';
        }
        html += '</div>';
        /* Dots */
        html += '<div class="mzc-review-dots" id="mzc-review-dots">';
        for (var r = 0; r < REVIEWS.length; r++) {
          html += '<button type="button" class="mzc-review-dot' + (r === 0 ? ' active' : '') + '" onclick="MzCartV2.reviewGoTo(' + r + ')" aria-label="Avis ' + (r+1) + '"></button>';
        }
        html += '</div></div>';
      } else {
        /* Single review */
        html += '<div class="mzc-review-wrap">' + buildReviewCard(REVIEWS[0], REVIEW_STARS_COLOR) + '</div>';
      }
    }

    html += '</div>';
    peindreCorps(body, html);

    /* 10/09 - FILET DE SECURITE : Lancelot a vu le tiroir s'ouvrir avec le bon
       compteur mais une liste d'articles vide (un grand blanc). La fusion fine
       peut echouer a apparier les lignes quand une couche d'habillage a bouge
       des blocs. On verifie donc que le nombre de lignes affichees correspond
       au panier reel ; sinon on repeint franchement, sans fusion. */
    try {
      var lignes = body.querySelectorAll('.mzc-item').length;
      if (lignes !== cart.items.length) {
        body.innerHTML = html;
      }
    } catch (e) { try { body.innerHTML = html; } catch(e2){} }

    if (SHOW_TIMER) startTimer(TIMER_MINUTES * 60);

    /* 02/09 — depuis la fusion, le carrousel d'avis n'est plus recree a chaque
       rendu : sans ce garde on lui rajouterait ses ecouteurs tactiles a chaque
       clic sur + ou -, et on remettrait sa position a zero pour rien. */
    var slider = document.getElementById('mzc-review-slider');
    if (slider && !slider.dataset.mzcSwipe) {
      slider.dataset.mzcSwipe = '1';
      window._mzcReviewIdx = 0;
      var touchStartX = 0;
      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      slider.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) reviewSlide(diff > 0 ? 1 : -1);
      }, { passive: true });
    }
  }

  /* ─── Review slider ─── */
  function reviewGoTo(idx) {
    var slider = document.getElementById('mzc-review-slider');
    var dots   = document.querySelectorAll('.mzc-review-dot');
    if (!slider) return;
    var count = slider.children.length;
    idx = (idx + count) % count;
    window._mzcReviewIdx = idx;
    slider.style.transform = 'translateX(-' + (idx * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
  }

  function reviewSlide(dir) {
    reviewGoTo((window._mzcReviewIdx || 0) + dir);
  }

  /* ─── Timer ─── */
  var timerInterval = null;
  function startTimer(seconds) {
    if (timerInterval) clearInterval(timerInterval);
    var remaining = seconds;
    function tick() {
      var m = Math.floor(remaining / 60), s = remaining % 60;
      var minEl = document.getElementById('mzc-timer-min');
      var secEl = document.getElementById('mzc-timer-sec');
      if (minEl) minEl.textContent = ('0'+m).slice(-2);
      if (secEl) secEl.textContent = ('0'+s).slice(-2);
      if (remaining <= 0) { clearInterval(timerInterval); return; }
      remaining--;
    }
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* ─── API ─── */
  /* 26/10/2026 : lecture du panier partagée (snippets/almea-panier-lecture.liquid, rendu dans le <head>). */
  /* 02/11 23h : lecture et +/- dans la langue du client (/de-de/, /en-gb/) : le tiroir affichait le nom du produit en français. RETOUR : remettre '/cart.js' et '/cart/update.js'. */
  function fetchCart() {
    return (window.almLirePanier ? window.almLirePanier() : fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js').then(function(r) { return r.json(); }))
      .then(function(cart) { return render(cart).then(function() { return cart; }); })
      .catch(function(err) { console.error('MzCartV2:', err); });
  }

  /* 02/11 23h (Lancelot) : un article retiré glisse et s'efface (0,2 s) au lieu de disparaître d'un coup. RETOUR : supprimer le bloc « if (quantity === 0 ...) ». */
  function update(key, quantity) {
    var item = document.querySelector('[data-key="' + key + '"]');
    if (quantity === 0 && item && !item.classList.contains('alm-sort') && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      item.classList.add('alm-sort');
      return new Promise(function (ok) { setTimeout(ok, 200); }).then(function () { return update(key, 0); });
    }
    if (item) item.classList.add('loading');
    var updates = {};
    updates[key] = quantity;
    if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart du serveur */
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { return render(cart).then(function() { return cart; }); })
    .catch(function(err) { console.error('MzCartV2:', err); fetchCart(); });
  }

  function add(id, qty) {
    if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart du serveur */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetchCart(); })
    .then(function() { open(); })
    .catch(function(err) { console.error('MzCartV2:', err); });
  }

  function addByHandle(handle, qty) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        if (p.variants && p.variants.length) return add(p.variants[0].id, qty || 1);
      })
      .catch(function(err) { console.error('MzCartV2 addByHandle:', err); });
  }

  function removeDiscount() {
    if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart du serveur */
    fetch('/discount/CLEAR_DISCOUNT_INVALID_CODE_XYZ', { method: 'GET', redirect: 'follow' })
      .then(function() {
        if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart du serveur */
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
      })
      .then(function() { return fetchCart(); })
      .catch(function(err) { console.error('MzCartV2:', err); });
  }

  function applyCoupon() {
    var input = document.getElementById('mzc-coupon-input');
    var btn   = document.getElementById('mzc-coupon-btn');
    var msg   = document.getElementById('mzc-coupon-msg');
    if (!input || !input.value.trim()) return;
    var code = input.value.trim();
    btn.disabled = true;
    btn.textContent = '...';
    if (msg) { msg.className = 'mzc-coupon-msg'; msg.textContent = ''; }
    if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart du serveur */
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
      .then(function() {
        if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart du serveur */
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
      })
      .then(function() { return fetchCart(); })
      .then(function(cart) {
        var all = (cart.cart_level_discount_applications || []).concat(cart.discount_applications || []);
        var found = all.find(function(d) { return d.title && d.title.toUpperCase() === code.toUpperCase(); });
        if (found) {
          if (msg) { msg.className = 'mzc-coupon-msg success'; msg.textContent = '✓ Code "' + found.title + '" angewendet!'; }
          if (input) input.value = '';
        } else {
          if (msg) { msg.className = 'mzc-coupon-msg error'; msg.textContent = '✗ Ungültiger oder bereits verwendeter Code.'; }
        }
        btn.disabled = false; btn.textContent = 'Anwenden';
      })
      .catch(function() {
        if (msg) { msg.className = 'mzc-coupon-msg error'; msg.textContent = '✗ Ein Fehler ist aufgetreten.'; }
        btn.disabled = false; btn.textContent = 'Anwenden';
      });
  }

  function init() {
    var overlay  = document.getElementById('mzc-overlay');
    var closeBtn = document.getElementById('mzc-close');
    if (overlay)  overlay.onclick  = close;
    if (closeBtn) closeBtn.onclick = close;
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function(e) {
      var cartLink = e.target.closest('a[href="/cart"], a.mz-action--cart, a[href$="/cart"]'); /* 31/10 03h (Lancelot : l'icône panier ouvrait l'ancienne page panier) : en DE/EN le lien est /de-de/cart ou /en-gb/cart, il n'était pas reconnu */
      if (cartLink && !cartLink.closest('.mzc-drawer')) { e.preventDefault(); fetchCart().then(open); }
    });
    /* 31/10 03h : icône panier touchée AVANT que ce script soit chargé (fiche produit) : on ouvre le tiroir maintenant (repère posé par sections/z-paniermasazen.liquid) */
    if (window.__almPanierDemande) { window.__almPanierDemande = 0; fetchCart().then(open); } else { fetchCart(); }
  }

  /* 18/09/2026 : init IMMEDIAT quand le tiroir est deja dans la page (section rendue juste apres le header, script
     non differe). Attendre DOMContentLoaded = attendre la fin de la lecture des 1,4 Mo de la page : le bouton panier
     ne repondait pas pendant 2 a 3 s apres l'apparition (« faut appuyer plusieurs fois »). */
  if (document.getElementById('mzc-drawer') || document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* 25/09 04h10 (Lancelot : « le sélecteur de nombre du panier bug ») : le chiffre change TOUT DE SUITE au toucher,
     plusieurs touchers rapides s'additionnent, et le panier n'est mis à jour qu'une fois (0,35 s après le dernier toucher).
     Avant : rien ne bougeait pendant ~0,7 s et deux touchers rapides envoyaient la même quantité. */
  var PAS_T = {};
  function step(key, delta) {
    var row = document.querySelector('#mzc-drawer .mzc-item[data-key="' + key + '"]'); if (!row) return;
    var val = row.querySelector('.mzc-qty-val');
    var cur = parseInt(row.getAttribute('data-alm-q') || (val ? val.textContent : '1'), 10) || 1;
    var q = Math.max(0, Math.min(99, cur + delta));
    row.setAttribute('data-alm-q', q);
    if (val) val.textContent = String(q);
    row.classList.add('alm-q-wait');
    clearTimeout(PAS_T[key]);
    PAS_T[key] = setTimeout(function () {
      update(key, q).then(function () { var r2 = document.querySelector('#mzc-drawer .mzc-item[data-key="' + key + '"]'); if (r2) { r2.removeAttribute('data-alm-q'); r2.classList.remove('alm-q-wait'); } });
    }, q === 0 ? 0 : 350);
  }

  return { bestDefiler: bestDefiler, open: open, close: close, fetch: fetchCart, update: update, step: step, add: add, addByHandle: addByHandle, applyCoupon: applyCoupon, removeDiscount: removeDiscount, reviewSlide: reviewSlide, reviewGoTo: reviewGoTo };
})();

/* 25/09 04h05 (Lancelot : « le panier doit s'ouvrir en 0 s quand j'ajoute ») : le tiroir s'ouvre DÈS le clic,
   contenu voilé + fine barre qui glisse en haut, puis le vrai contenu arrive (≈ 0,4 s) et le voile se lève. */
(function () {
  var st = document.createElement('style');
  st.textContent = '#mzc-drawer.alm-wait #mzc-body{opacity:0;pointer-events:none;transition:opacity .12s}'
    + '#mzc-drawer #mzc-body{transition:opacity .15s}'
    + '#mzc-drawer.alm-wait::before{content:"";position:absolute;top:0;left:0;height:2px;width:35%;background:#141210;z-index:20;animation:almWaitBar .9s ease-in-out infinite}'
    + '@keyframes almWaitBar{0%{left:-35%}100%{left:100%}}'
    + 'html body #mzc-drawer .alm-unit{display:flex !important;align-items:baseline !important;flex-wrap:wrap;gap:8px !important}'
    + 'html body #mzc-drawer .alm-unit .alm-line-now{order:0 !important;color:#141210 !important}'
    + 'html body #mzc-drawer .alm-unit .alm-line-was{order:1 !important;text-decoration:line-through !important;color:#9a948d !important;font-weight:400 !important;font-size:13px !important;margin:0 !important}'
    + 'html body #mzc-drawer .alm-save{display:none !important}'
    + 'html body #mzc-drawer .mzc-item-qty{overflow:hidden !important}'
    + 'html body #mzc-drawer .mzc-qty-btn,html body #mzc-drawer .mzc-qty-btn:hover,html body #mzc-drawer .mzc-qty-btn:focus,html body #mzc-drawer .mzc-qty-btn:active{background:transparent !important;-webkit-tap-highlight-color:transparent;outline:none;touch-action:manipulation}'
    + 'html body #mzc-drawer .mzc-item.alm-q-wait .alm-unit{opacity:.45;transition:opacity .12s}'
    + 'html body #mzc-drawer .mzc-item.alm-sort{opacity:0 !important;transform:translateX(24px) !important;transition:opacity .2s ease,transform .2s ease !important;pointer-events:none}';
  document.head.appendChild(st);
})();
window.almCartWait = function () {
  var d = document.getElementById('mzc-drawer'); if (!d) return;
  d.classList.add('alm-wait'); MzCartV2.open();
  clearTimeout(window.__almWaitT); window.__almWaitT = setTimeout(function () { d.classList.remove('alm-wait'); }, 5000);
};
window.openMzCart   = function() { return MzCartV2.fetch().then(function(cart) { MzCartV2.open(); var d = document.getElementById('mzc-drawer'); if (d) d.classList.remove('alm-wait'); return cart; }); };
window.closeMzCart  = function() { MzCartV2.close(); };
window.updateMzCart = function() { MzCartV2.fetch(); };
/* 26/10 : retour arrière (balayage) = page restaurée telle quelle, ou retour sur l'onglet → panier et pastille relus tout de suite. */
window.addEventListener('pageshow', function (e) { if (e.persisted) { if (window.almPanierEcrit) window.almPanierEcrit(); MzCartV2.fetch(); } });
document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { if (window.almPanierEcrit) window.almPanierEcrit(); MzCartV2.fetch(); } });

})();
